import messages from './messages';

const useSetInterventionReport = () => {
  return {
    setInterventionReportMessages: messages,
  };
};

export default useSetInterventionReport;
